<div cla [id]="getId()" [hidden]="getHidden()">
    <div class="col-md-12">
        <br />
        <form #formRef="ngForm">
            <div class="form-group" *ngFor="let email of recipients; let i = index">
                <span class="bs-h2 th-text-main" *ngIf="i === 0">Correo(s) electrónico(s)</span>
                <div class="input-group">
                    <input id="email{{i}}" type="email" class="form-control" [(ngModel)]="recipients[i].value"
                        name="emailIn{{i}}" [pattern]="getPattern()" #el="ngModel" required />
                    <div class="input-group-apend" (click)="removeRecipient(i)">
                        <span class="input-group-text" *ngIf="i > 0">
                            <i class="fa fa-times" aria-hidden="true"> </i>
                        </span>
                    </div>
                </div>
                <small class="help-block text-danger" *ngIf="el.errors?.pattern && el.touched">Por favor ingrese un
                    email
                    válido.</small>
            </div>
        </form>
    </div>
    <div class="col-md-12">
        <div class="">
            <button id="btnAgregarCorreo" [disabled]="!formRef.form.valid" class="btn-agregar-container w-100 p-0" (click)="addRecipient()"
                    data-toggle="tooltip" data-placement="top" title="Debe ingresar un correo">
                <div class="btn-agregar-content">
                    <div class="btn-agregar-text bs-main-and-action">AGREGAR OTRO CORREO</div>
                   <div class="button-icon-container">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                </div>
            </button>
        </div>
        <br />
    </div>
    <div class="col-md-12">
            <button id="btnEnviarCorreo" [disabled]="!formRef.form.valid" class="btn-agregar-container w-100 p-0" (click)="startOnCustomEvent()">
            <div class="btn-agregar-content">
                <div class="btn-agregar-text bs-main-and-action">ENVIAR</div>
            </div>
        </button>
    </div>
</div>


<!-- [(ngModel)]="recipients[i]" name="email{{i}}" -->